import React from 'react';

import { Alert } from '@lanl-web/lanl-components';
import { alert } from '../components/layout';

export const renderAlert = () => {
  return (
    alert !== '' && (
      <>
        <Alert>{alert}</Alert>
      </>
    )
  );
};
